export default __webpack_public_path__ + "static/media/portfolio-146.08efb6c3.jpg";